export const productStatuses = {
  available: 1, // Default status for products
  discontinued: 2, // Discontinued product status
  noPrice: 4, // No price available
  internal: 5, // Internal product status
  expired: 6 // Expired product status
}
